import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "../../../constants";
import { WhiteButton, YellowButton } from "../../UI/Button/button";
import classes from "./header.module.css";
import { ReactComponent as Menu } from "../../../assets/images/Landing/menu.svg";

const Header = ({ aboutUsRef, howItWorksRef, pricingRef, faqRef }) => {
  const [hidden, setHidden] = useState(false);
  const headerRef = useRef(null);
  const navigate = useNavigate();
  const [fixed, setFixed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1248);

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current && window.pageYOffset > 50) setFixed(true);
      else setFixed(false);
    };
    const handleResize = () => setIsMobile(window.innerWidth <= 1248);
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const arr = [
    { name: "About Us", link: "/#about-us", ref: aboutUsRef },
    { name: "How it works", link: "/#how-it-works", ref: howItWorksRef },
    // { name: "Pricing", link: "/pricing", ref: pricingRef },
    { name: "FAQs", link: "/#faqs", ref: faqRef },
    { name: "AWA - AI", link: "/awa-ai" },
    // { name: "Jobs", link: "/jobs" },
    { name: "Contact Us", link: "/contact-us" },
  ];

  return (
    <header
      className={`flex ${classes.header} ${fixed ? classes.header_fixed : ""}`}
      ref={headerRef}
    >
      <Link to="/">
        <Logo color={"#030659"} />
      </Link>
      <nav className={`${classes.nav} ${hidden ? classes.show : ""}`}>
        <div className={classes.mobileTop}>
          <Link to="/">
            <Logo color="#fff" />
          </Link>
          <span className={classes.cancel} onClick={() => setHidden(false)}>
            ✕
          </span>
        </div>
        <div className={classes.navbtns}>
          {arr.map((content, i) => (
            <button
              key={`button-${i}`}
              onClick={() => {
                setHidden(false);
                if (content?.ref) {
                  const offset = 100;
                  const sectionPosition =
                    content.ref.current.getBoundingClientRect().top + window.scrollY;
                  window.scrollTo({ top: sectionPosition - offset, behavior: "smooth" });
                } else {
                  navigate(content.link);
                }
              }}
            >
              {content.name}
            </button>
          ))}
        </div>
        <div className={`${classes.btn}`}>
          <YellowButton extra={classes.yellowBtn} onClick={() => navigate("/login")}>
            Log In
          </YellowButton>
          <WhiteButton extra={classes.whiteBtn} onClick={() => navigate("/register")}>
            Sign Up
          </WhiteButton>
        </div>
      </nav>
      <div className={classes.btns}>
        <YellowButton onClick={() => navigate("/login")}>Log In</YellowButton>
        <WhiteButton onClick={() => navigate("/register")}>Sign Up</WhiteButton>
      </div>
      <div className={`relative ${classes.menu}`}>
        <span onClick={() => setHidden(true)}>
          <Menu />
        </span>
      </div>
    </header>
  );
};

export default Header;
